import paths from '../../constants/paths';
import { uuid } from './utils';
import store from '../../store/store';
import config from '../../constants/config';
import axios from 'axios';

export function nbsApimetaPageView(data) {
  const url = config.NBS_API_URL + 'metaPageView';

  const formData = new FormData();
  for (let key in data) {
    if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
      formData.append(key, data[key]);
    }
  }
  axios.post(url, formData);
}

const PROTECTED_ROUTES = [
  paths.LIKES__ME,
  paths.FAVORITES__ME,
  paths.VIEWED__ME,
  paths.CHECKOUT,
];

export function getPage(url) {
  let page = '';
  const memberRegex = /member\/+\w/gi;
  if (memberRegex.test(url)) {
    page = '/user_profile';
  } else if (url === paths.PROFILE) {
    page = '/my_profile';
  } else if (url === paths.PROFILE__EDIT) {
    page = '/edit_profile';
  } else if (url === paths.CHATS || url === paths.CHATS__LIST) {
    page = '/chats';
  } else if (url === paths.CHATS__SENT) {
    page = '/sent-messages';
  } else if (
    url.includes(paths.GO_VIP_BARE) ||
    PROTECTED_ROUTES.indexOf(url) !== -1
  ) {
    if (
      store.getState().getMyProfile.response &&
      store.getState().getMyProfile.response.vip_user
    ) {
      page = url;
    } else {
      page = false;
    }
  } else {
    page = url;
  }

  return page;
}

export function gaRoutePageView(history, from) {
  // console.log('GA PAGE VIEW CALLED:::::', from);

  if (history) {
    let previousRoute = '';

    if (history.location) {
      // hard page load - direct access to route from browser url
      // console.log(
      //   `PAGE LOAD location ${from}: `,
      //   history.location.pathname +
      //     history.location.search +
      //     history.location.hash,
      //   history.action
      // );
      const { pathname, search } = history.location;
      const page = getPage(pathname);
      if (page) {
        gaPageView(page + search);
        previousRoute = `${history.location.pathname}${history.location.search}${history.location.hash}`;
      }
    }

    history.listen((location, action) => {
      // track react-router route change
      const currentRoute = `${location.pathname}${location.search}${location.hash}`;
      // console.log(`ROUTE CHANGE listen ${from}: ${currentRoute}, ${action}`, {
      //   previousRoute,
      //   currentRoute,
      // });

      const { pathname, search, hash } = location;
      const page = getPage(pathname);

      if (page && pathname !== paths.INDEX && previousRoute !== currentRoute) {
        gaPageView(page + search + hash);
        previousRoute = currentRoute;
      }
    });
  }
}

export function gaPageView(url) {
  // console.log('GA PAGE VIEW:::::', url, config.DOMAIN);
  const obj = {
    meta_source_url: `${config.DOMAIN}${url}`,
    meta_event_id: uuid(),
  };

  if (store.getState().metaPixels) {
    const { fbc, fbp } = store.getState().metaPixels;

    if (fbc) {
      obj.meta_fbc = fbc;
    }

    if (fbp) {
      obj.meta_fbp = fbp;
    }
  }

  nbsApimetaPageView(obj);
}
